<template>
	<Row class="bg-primary-900">
		<Container class="flex flex-col">
			<div class="py-12 lg:py-16">
				<!-- Title Section -->
				<div class="w-full mx-auto mb-6 text-center">
					<h2 class="text-white font-bold leading-tight mb-6 make-move-title">
						MAKE THIS 1 TRADE AT 2:59 PM ON FRIDAY AFTERNOON
						<br class="hidden lg:block" />
						<span class="highlight-yellow">
							AND YOU’LL THANK ME ON MONDAY MORNING
						</span>
					</h2>
				</div>

				<!-- Image Section -->
				<div
					class="image-container-make-move mb-8 lg:mb-12 lg:max-w-[800px] mx-auto"
				>
					<NuxtLink
						class="make-move-image-link"
						:to="ctaUrl"
						target="_blank"
					>
						<img
							src="/images/tim-looking-at-computer.webp"
							alt="Timothy Sykes looking at computer"
							width="1448"
							height="1086"
							class="make-move-image"
						/>
						<span class="play-btn">
							<svg
								width="169"
								height="169"
								viewBox="0 0 169 169"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle
									cx="84.5645"
									cy="84.1023"
									r="83.9826"
									fill="url(#paint0_radial_1196_7911)"
								/>
								<defs>
									<radialGradient
										id="paint0_radial_1196_7911"
										cx="0"
										cy="0"
										r="1"
										gradientUnits="userSpaceOnUse"
										gradientTransform="translate(84.5645 84.1023) rotate(90) scale(90.7907)"
									>
										<stop
											stop-color="white"
											stop-opacity="0"
										/>
										<stop
											offset="1"
											stop-color="#C5DCFF"
										/>
									</radialGradient>
								</defs>
							</svg>
							<img
								src="/images/icons/play-arrow.svg"
								width="116"
								height="116"
								alt="play video"
							/>
						</span>
					</NuxtLink>
				</div>

				<!-- CTA Button -->
				<CtaButton
					:to="ctaUrl"
					class="mx-auto text-center mt-8 lg:mt-12 cta-large"
					:blank="true"
					dataCtaType="live-masterclass-webinar"
				>
					<span class="flex items-center gap-2 lg:gap-4 text-xl lg:text-3xl">
						<svg
							width="48"
							height="48"
							viewBox="0 0 24 24"
							fill="currentColor"
						>
							<path d="M8 5v14l11-7z" />
						</svg>
						Get My Trade Plan Here!
					</span>
				</CtaButton>
			</div>
		</Container>
	</Row>
</template>

<script setup>
const ctaUrl = useCampaignUrl(
	"https://trading.timothysykes.com/weekend-windfalls/step/weekend-windfalls-v3/?utm_medium=ts.com&utm_campaign=Pl3JLJ"
);
</script>

<style lang="scss">
@import "@assets/utils.scss";

.make-move-title {
	font-size: 28px;
	@include breakpoint(md) {
		font-size: 40px;
	}
	@include breakpoint(lg) {
		font-size: 48px;
	}
}

.image-container-make-move {
	width: 100%;
	margin: 0 auto;
}

.make-move-image-link {
	display: block;
	position: relative;
	border-radius: 4px;
	overflow: hidden;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		box-shadow: inset 0 0 0 8px white;
		pointer-events: none;
		z-index: 1;
	}
}

.make-move-image {
	display: block;
	width: 100%;
	height: auto;
}

.play-btn {
	position: absolute;
	z-index: 2;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	margin: auto;
	display: flex;
	justify-content: center;
	align-items: center;

	&::before {
		position: absolute;
		content: "";
		height: 52px;
		width: 52px;
		background-color: white;
		z-index: 0;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}
	svg {
		position: absolute;
		margin: auto;
		top: 0;
		left: -25%;
		right: -25%;
		bottom: 0;
		z-index: 0;
		animation: blink 2s infinite;
	}

	img {
		position: relative;
		z-index: 1;
	}
}

@keyframes blink {
	0% {
		opacity: 0.5;
	}

	50% {
		opacity: 1;
	}

	100% {
		opacity: 0.5;
	}
}

.cta-large {
	padding: 12px 12px;
	@include max-breakpoint(lg) {
		padding: 12px 16px;
	}
}
.cta-large svg:nth-child(1) {
	width: 24px;
	@include breakpoint(lg) {
		height: 48px;
	}
}
.cta-large svg:nth-child(2) {
	@include max-breakpoint(lg) {
		display: none;
	}
}
</style>
